import { CalendarOutlined, LoginOutlined, LogoutOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Col, Row, DatePicker, Space, Modal } from "antd";
import { FC, useState } from "react";
import { format, addMonths } from "date-fns"; 

interface DatePickerSearchProps {
  handleDatepicker: (val: any) => void,
}

// const RightSelect: FC<RightSelectProps> = ({ setSelectPeriod }) => {
const DatePickerSearch: FC<DatePickerSearchProps> = ({ handleDatepicker}) => {
  const { RangePicker } = DatePicker;
  const [selectedDate, setSelectedDate] = useState<any>('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedDateShow, setSelectedDateShow] = useState<any>('');
  
  const handleDatePickerChange = (dates: any, dateStrings: [string, string]) => {
    setSelectedDate(dates);
    //console.log(dateStrings)
  };

  const formatDate = (date: Date) => {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "2-digit",
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  // Get the current date
  const currentDate = new Date();
  const formattedCurrentDate = formatDate(currentDate);

  const oneMonthAgo = addMonths(currentDate, -1);
  const formattedOneMonthAgo = formatDate(oneMonthAgo);


  const handleDatePickerContextClick = () => {
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    // setSelectedDate(null);
    // setSelectedDateShow(null);
  };

  const handleModalOk = () => {
    setIsModalVisible(false);
    setSelectedDateShow(selectedDate);
    handleDatepicker(selectedDate);
    
  };



  return (
    <CardWrapper>
      <DatePickerContainer>
        <DatePickerContext onClick={handleDatePickerContextClick}>
          <Row>
            <Col span={6} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <StyledCalendarOutlined />
            </Col>
            <Col span={16}>
              {selectedDateShow ? (
                <>
                  <DatePickerTitle>{formatDate(selectedDateShow[0].toDate())}</DatePickerTitle>
                  <DatePickerValue className="DatePicker">{selectedDateShow[0].format("dddd")}</DatePickerValue>
                </>
              ) : (
                <>
                  {/* Initialize with the current date */}
                  <DatePickerTitle>{formattedOneMonthAgo}</DatePickerTitle>
                  <DatePickerValue className="DatePicker">{oneMonthAgo.toLocaleDateString("en-US", { weekday: "long" })}</DatePickerValue>
                </>
              )}
            </Col>
          </Row>
        </DatePickerContext>
        <DatePickerContext onClick={handleDatePickerContextClick}>
          <Row>
            <Col span={6} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <StyledCalendarOutlined />
            </Col>
            <Col span={16}>
              {selectedDateShow ? (
                <>
                  <DatePickerTitle>{formatDate(selectedDateShow[1].toDate())}</DatePickerTitle>
                  <DatePickerValue className="report">{selectedDateShow[1].format("dddd")}</DatePickerValue>
                </>
              ) : (
                <>
                  {/* Initialize with the current date */}
                  <DatePickerTitle>{formattedCurrentDate}</DatePickerTitle>
                  <DatePickerValue className="report">{currentDate.toLocaleDateString("en-US", { weekday: "long" })}</DatePickerValue>
                </>
              )}
            </Col>
          </Row>
        </DatePickerContext>
      </DatePickerContainer>

      <Modal open={isModalVisible} onCancel={handleModalCancel} onOk={handleModalOk} title="กรุณาเลือกวันที่" cancelText="ยกเลิก" okText="ตกลง">
        <RangePicker  format="MMM DD, YYYY" bordered={false} onChange={handleDatePickerChange} />
      </Modal>
    </CardWrapper>
  );
};

export default DatePickerSearch;


const CardWrapper = styled.div`
  width: 100%;
  margin:auto;
`;

const DatePickerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  padding: 15px;
  margin: 15px 0;
`;

const DatePickerContext = styled.div`
  flex: 1;
 
  &:first-of-type {
    border-right: 1px solid #dedede;
  }
  cursor:pointer;
`;

const DatePickerTitle = styled.h5`
  font-size: 15px;
  margin: 0;
`;

const DatePickerValue = styled.p`
  
  letter-spacing: 1px;
  margin: 5px 0;
`;

const StyledLoginOutlined = styled(LoginOutlined)`
  font-size: 36px;
`;

const StyledCalendarOutlined = styled(CalendarOutlined)`
  font-size: 36px;
`;

const StyledLogoutOutlined = styled(LogoutOutlined)`
  font-size: 36px;
`;




